export const live = {
    zbz: "Đang phát trực tiếp",
    ljks: "Bắt đầu ngay",
    hmyzb: "Bạn chưa từng phát trực tiếp~",
    zbyg: "Thông báo phát trực tiếp",
    yjs: "Đã kết thúc",
    jszb: "Kết thúc phát trực tiếp",
    gbzb: "Đóng phát trực tiếp",
    jxzb: "Tiếp tục phát trực tiếp",
    bctp: "Lưu hình ảnh",
    fxlj: "Chia sẻ liên kết",
    zbydk: "Phát trực tiếp đã ngắt kết nối, vui lòng đợi...",
    fh: "Quay lại",
    wjcdypsb: "Không phát hiện thiết bị âm thanh",
    czsb: "Thao tác Canvas thất bại:",
    tpjzsb: "Tải hình ảnh thất bại, vui lòng kiểm tra URL có chính xác và hình ảnh có thể truy cập được không",
    zbjl: "Lịch sử phát trực tiếp",
    sqjl: "Lịch sử đăng ký",
    lts: "Phòng trò chuyện",
    ren: "người",
    gdcy: "Thành viên khác",
    cy: "Thành viên",
    jcjy: "Bỏ cấm chat",
    jy: "Cấm chat",
    qbjy: "Cấm chat tất cả",
    zbjs: "Giới thiệu buổi phát trực tiếp",
    srnr: "Vui lòng nhập nội dung",
    tczbj: "Bạn đã bị đá khỏi phòng phát trực tiếp",
    qd: "Xác nhận",
    zbjjjs: "Buổi phát trực tiếp của bạn sẽ tự động kết thúc sau 10 phút nữa!",
    zbsc: "Thời lượng phát trực tiếp:",
    ljgkrs: "Tổng số người xem:",
    dzs: "Số lượt thích:",
    zbjies: "Phát trực tiếp đã kết thúc",
    ybjy: "Bạn đã bị cấm chat",
    jycg: "Bỏ cấm chat thành công",
    jinycg: "Cấm chat thành công",
    qbjinycg: "Cấm chat tất cả thành công",
    qbjycg: "Bỏ cấm chat tất cả thành công",
    cwzb: "Trở thành streamer",
    lxgzry: "Vui lòng liên hệ nhân viên để trở thành streamer",
    lxfs: "Thông tin liên hệ",
    zb: "Phát trực tiếp",
    xkt: "Lớp học Biking",
    sqzb: "Đăng ký phát trực tiếp",
    bczbzt: "Chủ đề buổi phát trực tiếp",
    srzt: "Vui lòng nhập chủ đề",
    bczbjj: "Giới thiệu buổi phát trực tiếp",
    kbsj: "Thời gian bắt đầu",
    xzrisj: "Chọn ngày và giờ",
    tishi: "Thông báo",
    dksdzb: "Có 1 buổi phát trực tiếp chưa bắt đầu vào thời điểm này",
    cxsj: "Thời lượng",
    xzsc: "Chọn thời lượng",
    fmt: "Ảnh bìa",
    fmtbnwk: "Ảnh bìa không được để trống",
    sc: "Tải lên",
    yssc: "Tối đa 10MB, vui lòng nén lại trước khi tải lên",
    sccct: "Vui lòng tải lên ảnh có kích thước 360*170",
    tjsq: "Gửi đơn đăng ký",
    tpcj: "Cắt ảnh",
    tzcjwz: "Điều chỉnh vị trí khung cắt, chọn vùng muốn giữ lại",
    scdtp: "Ảnh đã tải lên",
    yl: "Xem trước (360×170)",
    cjtp: "Cắt ảnh",
    quxiao: "Hủy bỏ",
    qsrzbjj: "Vui lòng nhập giới thiệu buổi phát trực tiếp",
    qxzrq: "Vui lòng chọn ngày",
    qxzsc: "Vui lòng chọn thời lượng",
    kssjdydqsj: "Thời gian bắt đầu phải lớn hơn thời gian hiện tại",
    sctxtpdx: "Kích thước ảnh đại diện tải lên không được vượt quá 10MB!",
    tjcg: "Gửi thành công",
    jkshnr: "Chúng tôi sẽ sớm xem xét nội dung đăng ký của bạn",
    hmysqgzb: "Bạn chưa từng đăng ký phát trực tiếp~",
    shz: "Đang xem xét",
    tongg: "Đã thông qua",
    jujue: "Từ chối",
    yugao: "Thông báo",
    huifang: "Phát lại",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/vi.js